<template>
<div class="navbar container">
    <router-link to='/'>
        <div class="navbar-logo">
            <img src="../../assets/logo.png" alt="" width="50px" height="30px" style="margin-right: 10px">
            <img src="../../assets/text-logo.png" height="10px" width="100px" alt="" >

        </div>
    </router-link>
    <div class="navigation-panel">
        <router-link to='/delivery'>
          <md-button class="nav-button">Доставка</md-button>
        </router-link>
        <md-button class="nav-button">Контакты</md-button>
        <md-button class="nav-button">Галерея</md-button>
        <md-button class="nav-button">О нас</md-button>
    </div>
</div>
</template>

<script>
    export default {
        name: "NavBar"
    }
</script>

<style lang="scss">
    .navbar {
        justify-content: space-between;
        background: #ffffff;
        height: 56px;
        display: flex;
        align-items: center;
        margin-left: 20vh;
        ul {
            display: inline-flex;
            li {
                cursor: pointer;
                list-style: none;
                padding: 30px 16px 25px;
                &:hover {
                    background-color: #a2a2a2;
                }
            }

        }
    }
</style>
